import React from 'react';
import { useTranslation } from 'react-i18next';
import { isArray, isEmpty } from 'lodash/lang';
import moment from 'moment/moment';

import { i18nt } from '../../../../../../../root';
import { NS_COMMON, NSC_PATIENT, NSPP_PATIENT } from '../../../../../../../services/i18n/namespaces';
import { getPatientAgeFromDob } from '../../../../../../../services/patient';
import { calculateBMI } from '../../../PatientInfo/PatientInfoMainSection/AddOrEditPatientInfoModal/PatientDemographics/PatientDemographics';
import { usePatientProfile } from '../../PatientProfileContext';

export default function PatientDetailsDemographicsInformation() {
  const { t } = useTranslation();
  const { patientInfo } = usePatientProfile();
  const { dob, sex, heightFt, heightIn, weight, races, ethnicities } = patientInfo || {};
  const bmiValue = calculateBMI(weight, heightFt, heightIn);

  return (
    <div className="patient-profile-information-content-section">
      <div className="patient-profile-information-header">
        <div className="patient-profile-information-header-title">{t('patientDemographics', { ns: NSPP_PATIENT })}</div>
      </div>

      <div className="patient-profile-information-data-row">
        <div className="patient-profile-information-label">
          <div className="patient-profile-information-label-field">{`${t('dateOfBirth', { ns: NS_COMMON })}:`}</div>
          <div className="patient-profile-information-label-field">{`${moment.isMoment(dob) &&
            dob.format('DD/MMM/YYYY')} (${getPatientAgeFromDob(patientInfo)})`}</div>
        </div>

        <div className="patient-profile-information-label">
          <div className="patient-profile-information-label-field">{`${t('sex', { ns: NSC_PATIENT })}:`}</div>
          <div className="patient-profile-information-label-field">
            {sex ? t(`sexMap.${sex}`, { ns: NSC_PATIENT }) : '-'}
          </div>
        </div>

        <div className="patient-profile-information-label">
          <div className="patient-profile-information-label-field">{`${t('info.height', { ns: NSPP_PATIENT })}:`}</div>
          <div className="patient-profile-information-label-field">{heightFt ? `${heightFt}'${heightIn}"` : '-'}</div>
        </div>

        <div className="patient-profile-information-label">
          <div className="patient-profile-information-label-field">{`${t('info.weight', { ns: NSPP_PATIENT })}:`}</div>
          <div className="patient-profile-information-label-field">{weight ? `${weight} lbs` : '-'}</div>
        </div>

        <div className="patient-profile-information-label">
          <div className="patient-profile-information-label-field">{`${t('BMI', { ns: NSPP_PATIENT })}:`}</div>
          <div className="patient-profile-information-label-field">{bmiValue || '-'}</div>
        </div>
      </div>

      <div className="patient-profile-information-data-row">
        <div className="patient-profile-information-label">
          <div className="patient-profile-information-label-field">{`${t('race', { ns: NSPP_PATIENT })}:`}</div>
          <div className="patient-profile-information-label-field">{normalizeRaceValues()}</div>
        </div>

        <div className="patient-profile-information-label">
          <div className="patient-profile-information-label-field">{`${t('ethnicity', { ns: NSPP_PATIENT })}:`}</div>
          <div className="patient-profile-information-label-field">{normalizeEthnicityValues()}</div>
        </div>
      </div>
    </div>
  );

  function normalizeRaceValues() {
    return races && isArray(races) && !isEmpty(races)
      ? races.map(race => i18nt(`${NSC_PATIENT}:raceMap.${race}`)).join(', ')
      : '-';
  }

  function normalizeEthnicityValues() {
    return ethnicities && isArray(ethnicities) && !isEmpty(ethnicities)
      ? ethnicities?.map(ethnicity => i18nt(`${NSC_PATIENT}:ethnicityMap.${ethnicity}`)).join(', ')
      : '-';
  }
}
